
const environment = process.env.ENVIRONMENT;

const baseUrl= environment == 'PRODUCTION'?'https://coffee-form-zegwe.ondigitalocean.app' : 'https://whale-app-jkvoc.ondigitalocean.app';

export default baseUrl;
